import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IoEyeOutline } from "react-icons/io5";
import { ToastContainer, toast } from "react-toastify";
import { selectMode } from "../../../service/slice/ThemeSlice";
import { Link } from "react-router-dom";
import NoData from "../../NoData";
import { encode } from 'js-base64';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import Loading from "../../Loading";

export default function UserList() {

    DataTable.use(DT);
    const [userDetails, setUserDetails] = useState([]);
    const adminToken = localStorage.getItem("authAdminToken");
    const [loading, setLoading] = useState(true);

    // Show Details Section
    const fetchAllUser = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/getAllUser`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${adminToken}`
            },
        });

        return response.json();
    };

    useEffect(() => {
        fetchAllUser().then((res) => {
            if (res.status) {
                setLoading(false);
                setUserDetails(res.users);
            } else {
                toast.error("Unable to load user details. Please try again later.");
            }
        }).catch((err) => {
            toast.error("Failed to fetch users. Please check your connection and try again.");
        });
    }, []);

    const theme = useSelector(selectMode);

    const themeColor = {
        color: theme === 'light' ? '#000' : '#fff',
        background: theme === 'light' ? '#fff' : 'rgb(203 204 225 / 20%)',
    };

    return (
        <>
            {/* Toast container */}
            < ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            {loading ?
                <Loading />
                :
                <div className="container-xxl flex-grow-1 container-p-y" style={{ margin: "4em 25em" }}>
                    <div className="card" style={themeColor}>
                        <div className="card-header ">
                            <h5 className="card-title mb-0" style={themeColor}>User List</h5>
                        </div>

                        {userDetails.length > 0 ?

                            <div className="card-body p-0">
                                <div className="table-responsive">
                                    <DataTable data={userDetails.map((user, index) => {
                                        const medium = JSON.parse(user.medium);
                                        const mediumList = medium.join(", ");

                                        return [
                                            index + 1,
                                            `${user.first_name} ${user.last_name}`,
                                            user.email,
                                            user.board,
                                            mediumList,
                                            user.status ? '<div class="text-success">Active</div>' : '<div class="text-danger">Inactive</div>',
                                            user.id
                                        ];
                                    })}

                                        slots={{
                                            6: (data) => {
                                                return <div className="d-flex gap-3" >
                                                    <a class="btn btn-outline-primary btn-icon border-none" href={`/admin/customerdetails/${encode(data)}`}>
                                                        <IoEyeOutline style={{ color: "#666cff" }} />
                                                    </a>
                                                </div>;
                                            }
                                        }}
                                        className="display">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Board</th>
                                                <th>Medium</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                    </DataTable>
                                </div>
                            </div>
                            :
                            <NoData />
                        }

                    </div>
                </div>
            }
        </>
    )
}
